import { render } from "./Chart.vue?vue&type=template&id=27e5e54a&bindings={}"
import script from "./Chart.vue?vue&type=script&lang=ts"
export * from "./Chart.vue?vue&type=script&lang=ts"
script.render = render

export default script